
import { PubSub } from '@dinosband/dbi-utils'
import { MessengerPubSubEvent } from './const'

type Subscription = () => void

export class SubscriptionManager {

  private _pubsub!: PubSub
  private _subscriptions: Subscription[] = []

  init (pubsub: PubSub) {
    this._pubsub = pubsub
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subscribe (event: MessengerPubSubEvent, callback: (data: any) => void) {
    const subscription = this._pubsub.subscribe(event, callback)
    this._subscriptions.push(subscription)
    return subscription
  }

  cleanup () {
    this._subscriptions.forEach((i) => i())
    this._subscriptions = []
  }

  /*
  private _subscribers: { subscriber: unknown, subscriptions: Subscription[] }[] = []
  private _pubsub = new PubSub()

  publish (event: MessengerPubSubEvent, data?: unknown) {
    this._pubsub.publish(event, data)
  }

  subscribe (subscriber: unknown, event: MessengerPubSubEvent, callback: Callback) {
    const subscription = this._pubsub.subscribe(event, callback)
    let selected = this._subscribers.find((i) => i.subscriber === subscriber)
    if (!selected) {
      selected = { subscriber, subscriptions: [] }
      this._subscribers.push(selected)
    }
    selected.subscriptions.push(subscription)
    return subscription
  }

  unsubscribe (subscriber: unknown) {
    const selected = this._subscribers.find((i) => i.subscriber === subscriber)
    selected?.subscriptions.forEach((i) => i())
  }
  */
}